import { Modal, SubmitButton } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";

interface MultiFactorAuthenticationInfoModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfigure: () => void;
    showInitalConfigurationMsg?: boolean;
}

export const MultiFactorAuthenticationInfoModal = ({
    isOpen,
    showInitalConfigurationMsg,
    onClose,
    onConfigure,
}: MultiFactorAuthenticationInfoModalProps) => {
    return (
        <Modal
            size="medium"
            isOpen={isOpen}
            showInitalConfigurationMsg={showInitalConfigurationMsg}
            onClose={onClose}
            onConfigure={onConfigure}
        >
            <ModalContent showInitalConfigurationMsg={showInitalConfigurationMsg} onConfigure={onConfigure} />
        </Modal>
    );
};

const ModalContent = ({
    onConfigure,
    showInitalConfigurationMsg,
}: {
    showInitalConfigurationMsg?: boolean;
    onConfigure: () => void;
}) => {
    const history = useHistory();

    const handleSubmit = () => {
        history?.push("/settings/profile/MFASetting");
        onConfigure();
    };

    return (
        <>
            <Modal.Header>Multi Factor Authentication</Modal.Header>

            <Modal.Body>
                {showInitalConfigurationMsg ? (
                    <>
                        <p className="mb-2">
                            We have made Multi Factor Authentication (MFA) mandatory as part of our efforts to make your
                            account more secure.
                        </p>
                        <p>Please configure MFA now.</p>
                    </>
                ) : (
                    <p className="mb-2">
                        This field change requires Multi Factor Authentication (MFA) for increased security, Please add
                        phone number to receive OTP.
                    </p>
                )}
            </Modal.Body>

            <Modal.Footer>
                <SubmitButton onClick={handleSubmit}>Configure</SubmitButton>
            </Modal.Footer>
        </>
    );
};
